<template>
    <div class="blacklist-editor">
        <textarea
            v-model="textValue"
            rows="12"
            class="form-control mb-2"
        ></textarea>

        <button
            @click="save"
            :disabled="loading"
            class="btn btn-primary"
        >Сохранить</button>

        <p v-if="message" class="status-message py-0">{{ message }}</p>
    </div>
</template>

<script>
import PlatformHelper from "../../helpers/platform";

export default {
    name: "BlacklistedPhonesEditor",
    props: ['platform_id'],
    data() {
        return {
            textValue: "",
            loading: false,
            message: ""
        };
    },
    mounted() {
        this.loadPhones();
    },
    computed: {
        platform_name() {
            return PlatformHelper.get(this.platform_id).name;
        }
    },
    methods: {
        async loadPhones() {
            this.loading = true;
            try {
                const res = await axios.get(`/api/blacklisted-phones/${this.platform_id}`);

                if (res.data.blacklisted_phones) {
                    this.textValue = res.data.blacklisted_phones.join("\n");
                }
            } catch (e) {
                console.error(e);
                this.message = "Не удалось загрузить данные.";
            }
            this.loading = false;
        },

        async save() {
            this.loading = true;
            this.message = "";

            try {
                const phones = this.textValue
                    .split("\n")
                    .map(p => p.trim())
                    .filter(p => p.length > 0); // убираем пустые строки

                const res = await axios.post(`/api/blacklisted-phones/${this.platform_id}`, {
                    phones: phones
                });

                this.message = "Сохранено успешно.";
            } catch (e) {
                console.error(e);
                this.message = "Ошибка при сохранении.";
            }

            this.loading = false;

            await this.loadPhones();
        }
    }
};
</script>

<style scoped>
.blacklist-editor {
    display: flex;
    flex-direction: column;
    max-width: 500px;
}

.save-button {
    padding: 8px 16px;
    cursor: pointer;
}

.status-message {
    margin-top: 8px;
    color: #444;
}
</style>
